interface IProps {
    children: React.ReactNode
    className?: string
}

export const CardTitle = ({ children, className }: IProps) => {
    return <div className={`text-lg font-bold border-b border-black pb-2 mb-2 leading-none ${className}`}>
        {children}
    </div>
}

const Card = ({ children, className }: IProps) => {
    return <div className={`p-2 bg-gray-50 border border-gray-200 rounded-lg ${className}`}>
        {children}
    </div>
}

export default Card